<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "catalog_sorting_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="row">
            <div class="title col-xs-9">
                {{ "catalog_search_placeholder" | translate | uppercase }}
            </div>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="searchEnable.value" (toggleActiveEvent)="setEnabledSearch($event)"></sp-switch>
            </div>
        </div>
        <div class="form-group mb-0">
            <label class="col-xs-12">{{ "control_input_placeholder" | translate }}</label>
            <div class="col-xs-12 mb-5">
                <input class="form-control" [formControl]="searchPlaceholder" />
            </div>
        </div>
        <div class="form-group mb-20">
            <div class="col-xs-12">
                <hr class="panel-options-divider" />
            </div>
        </div>
        <div class="row">
            <div class="title col-xs-9">
                {{ "catalog_sorting_title" | translate | uppercase }}
            </div>
            <div class="col-xs-3 text-right">
                <sp-switch [active]="enable.value" (toggleActiveEvent)="setEnabledButton($event)"></sp-switch>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_fields_appearance" | translate }}
            </label>
            <div class="col-xs-12">
                <div class="btn-group d-flex">
                    <button
                        class="btn btn-grey w-100"
                        [class.active]="borderStyle.value === inputBorderEnum.FULL_BORDER"
                        (click)="setBorderStyle(inputBorderEnum.FULL_BORDER)"
                    >
                        <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                    </button>
                    <button
                        class="btn btn-grey w-100"
                        [class.active]="borderStyle.value === inputBorderEnum.BOTTOM_BORDER"
                        (click)="setBorderStyle(inputBorderEnum.BOTTOM_BORDER)"
                    >
                        <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                    </button>
                </div>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_input_text_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker [color]="textColor.value" (colorChangeEvent)="setTextColor($event)"></sp-color-picker>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_background_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="backgroundColor.value"
                    (colorChangeEvent)="setBackgroundColor($event)"
                ></sp-color-picker>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_border_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [color]="borderColor.value"
                    (colorChangeEvent)="setBorderColor($event)"
                ></sp-color-picker>
            </div>
        </div>

        <div class="form-group mb-20">
            <label class="col-xs-6 control-label">
                {{ "control_radius" | translate }}
            </label>
            <div class="col-xs-6">
                <sp-input-num
                    prefixImgUrl="./assets/img/border-radius-icon.svg"
                    suffixText="px"
                    [min]="BORDER_RADIUS_MIN"
                    [max]="BORDER_RADIUS_MAX"
                    [onlyIntegers]="true"
                    [value]="borderRadius.value"
                    (valueChange)="setBorderRadius($event)"
                    (blurEvent)="setBorderRadius($event)"
                ></sp-input-num>
            </div>
        </div>

        <div class="form-group mb-0">
            <label class="col-xs-6 control-label">{{ "control_fields_size" | translate }}</label>
            <div class="col-xs-6">
                <sp-radio-group
                    [selected]="inputSize.value"
                    [type]="ERadioGroupType.size"
                    (changeSelectedEvent)="setInputSize($event)"
                ></sp-radio-group>
            </div>
        </div>
    </div>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
